export const validateAndDirty = {
  shouldDirty: true,
  shouldValidate: true,
};
